export const FIND_EMPLOYEES_FAILURE = 'FIND_EMPLOYEES_FAILURE';

export const findEmployeesFailure = ({ error, request }) => ({
    type: FIND_EMPLOYEES_FAILURE,
    payload: error,
    error: true,
    meta: {
        request
    }
});